/* unplugin-vue-components disabled */import { render } from "./DownloadYearHang.vue?vue&type=template&id=a384abda"
import script from "./DownloadYearHang.vue?vue&type=script&lang=js"
export * from "./DownloadYearHang.vue?vue&type=script&lang=js"

import "./DownloadYearHang.vue?vue&type=style&index=0&id=a384abda&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__